import { useEffect, useState } from "react";

export function useKeyboardVisible(threshold = 150) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    let restingHeight = viewport.height;
    let orientationTimer: ReturnType<typeof setTimeout>;

    const updateResting = () => {
      restingHeight = viewport.height;
      setVisible(false);
    };

    const onOrientationChange = () => {
      // Wait for the viewport to fully settle after rotation
      clearTimeout(orientationTimer);
      orientationTimer = setTimeout(updateResting, 500);
    };

    const onViewportResize = () => {
      const diff = restingHeight - viewport.height;
      if (diff > threshold) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    viewport.addEventListener("resize", onViewportResize);
    // orientationchange is more reliable than window resize for rotation
    window.addEventListener("orientationchange", onOrientationChange);
    // fallback for desktop / devices without orientationchange
    window.addEventListener("resize", onOrientationChange);

    return () => {
      viewport.removeEventListener("resize", onViewportResize);
      window.removeEventListener("orientationchange", onOrientationChange);
      window.removeEventListener("resize", onOrientationChange);
      clearTimeout(orientationTimer);
    };
  }, [threshold]);

  return visible;
}
